import request from '@/utils/request'


// 查询课程/门店/动态标签关联列表
export function listLabel(query) {
  return request({
    url: '/course/label/list',
    method: 'get',
    params: query
  })
}

// 查询课程/门店/动态标签关联分页
export function pageLabel(query) {
  return request({
    url: '/course/label/page',
    method: 'get',
    params: query
  })
}

// 查询课程/门店/动态标签关联详细
export function getLabel(data) {
  return request({
    url: '/course/label/detail',
    method: 'get',
    params: data
  })
}

// 新增课程/门店/动态标签关联
export function addLabel(data) {
  return request({
    url: '/course/label/add',
    method: 'post',
    data: data
  })
}

// 修改课程/门店/动态标签关联
export function updateLabel(data) {
  return request({
    url: '/course/label/edit',
    method: 'post',
    data: data
  })
}

// 删除课程/门店/动态标签关联
export function delLabel(data) {
  return request({
    url: '/course/label/delete',
    method: 'post',
    data: data
  })
}
